var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mr-collapsible-extension',{attrs:{"title":_vm.title,"is-loading":_vm.isLoading,"has-error":_vm.hasError}},[_c('artifacts-list',{attrs:{"artifacts":_vm.artifacts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }